import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar"
import { useEffect, useState } from "react";
import PrivateRoute from "../utils/PrivateRoute";
import { ToastContainer } from "react-toastify";
import { connect } from "react-redux";
import logService from "../services/logging/logService";
import LoggerInitializer from "../components/LoggerInitializer";

function DefaultLayout({ theme }) {

  // const [theme] = useState(localStorage.getItem('theme'));
  const [bgUrl, setBgUrl] = useState('');

  useEffect( () => {
 /*    const bg = new URL(`../assets/images/${theme === 'dark' ? 'bg_desktop.png' : 'bg_desktop_light.jpeg'}`, import.meta.url).href;
    setBgUrl(bg); */
  }, [theme]);



  useEffect( () => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }, [theme]);


  const [pageTitle, setPageTitle] = useState('');

  // Tracciamento navigazione 
  const location = useLocation();
  
  // Registra il cambiamento di pagina
  useEffect(() => {
    const currentPath = location.pathname;
    const pageNameWithoutDashes = currentPath.split('/').pop()?.replace(/-/g, ' ') || '';
    const pageName = pageNameWithoutDashes.replace(/\b\w/g, (c) => c.toUpperCase());
    
    // Imposta il titolo della pagina basato sul percorso
    setPageTitle(pageName || 'Home');
    
    // Log della navigazione
    if (localStorage.getItem('token')) {
      logService.logNavigation(
        currentPath,
        `Visitata pagina: ${pageName || currentPath}`,
        { 
          title: pageName,
          path: currentPath,
          search: location.search,
          hash: location.hash
        }
      );
      console.log(`Navigazione registrata: ${currentPath}`);
    }
  }, [location.pathname, location.search]);
  
  return (
    <PrivateRoute>
      <div className="bg-contain min-h-screen font-body text-neutral-600 dark:text-white" style={{ backgroundImage: `url(${bgUrl})` }}>
        <div className="bg-white/85 min-h-screen dark:bg-black/15">
          <Navbar pageTitle={pageTitle} />
          <LoggerInitializer />
          <ToastContainer />
          <Outlet context={[pageTitle, setPageTitle]} />
        </div>
      </div>
    </PrivateRoute>
  )
}


const mapStateToProps = ({ menu }) => {
  const { theme } = menu;
  return { theme };
};

export default connect(
  mapStateToProps,
  {}
)(DefaultLayout);
